import { render, staticRenderFns } from "./ClientContextMenu.vue?vue&type=template&id=e7166e5e"
import script from "./ClientContextMenu.vue?vue&type=script&lang=js"
export * from "./ClientContextMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports